import { Box } from '@rbilabs/universal-components';

import { primitive } from 'styles/constants';

export const Container = Box.withConfig({
  borderRadius: primitive.$borderRadius,
  shadow: '1',
  overflow: 'hidden',
});

export const MapContainer = Box.withConfig({
  height: '$48',
  width: 'full',
});

export const DeliveryDetailsContainer = Box.withConfig({
  background: primitive.$white,
  width: 'full',
});
